import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const StyledLogomark = styled.img`
    width: 59px;
    height: 41px;
`;

export function Logomark() {
    const { locale } = useIntl();
    const languageCode = locale.split('-')[0];

    return (
        <StyledLogomark
            alt={__('99designs by Vista')}
            src={`https://assets.99static.com/logos/${languageCode}/logomark_grey.svg`}
        />
    );
}
